module.exports = __webpack_public_path__ + "static/img/18.27231bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/18.png
// module id = aZRL
// module chunks = 0